<template>
	<div class="scrollable only-y">
		<el-row :gutter="30">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
				<div class="page-header card-base">
					<h2 class="no-m white-text">{{ $t("dashboard.welcome") }} {{capitalizeFirstLetter(user.name)}}</h2>
					<p style="float:left;">{{ $t("dashboard.welcome_description") }}</p>
				</div>
				<div class="page-header card-base">
					<h2 class="no-m">{{ $t("dashboard.setup") }}</h2>
					<el-row :gutter="30">
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mt-20">
							<div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="loadingConsumen" element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)" style="background-color:#249393;">
								<div class="widget-header ph-20 pt-20">
									<div class="flex justify-center align-center">
										<div class="widget-icon-box mr-20 animated fadeInRight">
											<i class="mdi mdi-account-settings-variant widget-icon accent-text fs-30 card-base p-10"></i>
										</div>
										<div class="widget-info box grow text-truncate animated fadeInLeft">
											<div>Consumen</div>
											<h1>{{ totalConsumen }}</h1>
										</div>
									</div>
								</div>
								<component :is="asyncComponent" :type="'line'" :options='{ width: "100%", height: 80, fill: ["#C6D9FD"] }' :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 11, 12, 13, 12, 12, 14].toString()"/>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mt-20">
							<div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="loadingProduct" element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)" style="background-color:#5f8fdf;">
								<div class="widget-header ph-20 pt-20">
									<div class="flex justify-center align-center">
										<div class="widget-icon-box mr-20 animated fadeInRight">
											<i class="mdi mdi-basket widget-icon accent-text fs-30 card-base p-10"></i>
										</div>
										<div class="widget-info box grow text-truncate animated fadeInLeft">
											<div>Products</div>
											<h1>{{ totalProduct }}</h1>
										</div>
									</div>
								</div>
								<component :is="asyncComponent" :type="'bar'" :options='{ width: "100%", height: 80, fill: ["#C6D9FD"] }' :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mt-20">
							<div class="card-base card-shadow--medium mb-30 widget small-widget" v-loading="loadingTemplate" element-loading-text="Loading..."
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)" style="background-color:#2B80F6;">
								<div class="widget-header ph-20 pt-20">
									<div class="flex justify-center align-center">
										<div class="widget-icon-box mr-20 animated fadeInRight">
											<i class="mdi mdi-message widget-icon accent-text fs-30 card-base p-10"></i>
										</div>
										<div class="widget-info box grow text-truncate animated fadeInLeft">
											<div>Message Template</div>
											<h1>{{ totalTemplate }}</h1>
										</div>
									</div>
								</div>
								<component :is="asyncComponent" :type="'line'" :options='{ width: "100%", height: 80, fill: ["#C6D9FD"] }' :data="[1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 6, 7, 8, 8, 8, 9, 10].toString()"/>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import config from '../config'
import api from '@/networkClient'
import moment from 'moment'
import store from '@/store'

export default {
	name: 'Dashboard',
	data () {
		return {
			asyncComponent: 'peity',
			resized: false,
			config:config,
			loadingWA: false,
			loadingProduct: true,
			loadingConsumen: true,
			loadingTemplate: true,
			totalConsumen: 0,
			totalProduct: 0,
			totalTemplate: 0,
			loadingContact: false,
			totalContact: 0,
			currentMonth: moment().format("M"),
			user: {
				name: store.getters.userName,
				company: store.getters.companyName,
			},
			isLoading:true,
		}
	},
	computed: {
		smallWidget() {
			return this.dashboardWidth >= 970 && this.dashboardWidth <= 1412 && this.windowWidth >= 1200
		}
	},
	methods: {
		log(data) {
			console.log(data, " <<log");
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		parseDate(dateString) {
	    	var date = new Date(dateString);
	    	return date.getTime();
	  	},
		async overview_wa(){
			await api({
				method: 'post',
				url: config.baseApi+'user/billing',
				data: {
					months: [this.currentMonth],
					with_date: true
				}
			}).then(result => {
				let datas = result.data.data[0]
				let tempTotal = 0
				let tempBill = 0

				_.forOwn(datas.total.delivered, (value, key) => {
					tempTotal += value
				})

				_.forOwn(datas.total.bill, (value, key) => {
					tempBill += value
				})

				this.totalBill = tempBill
				this.totalWA = tempTotal

			}).catch(error => {
				return error
			})
			this.loadingWA = false
			this.loadingProduct = false
		},

		async overview_contact(){
			await api({
				method: 'get',
				url: config.baseApi+'phonebook/all',
			}).then(result => {
				let datas = result.data
				this.totalContact =datas.numRows
			}).catch(error => {
				return error
			})
			this.loadingContact = false
		},

		goToUrl(url) {
			let win = window.open(url, '_blank');
			win.focus();
		},

		async loadConsumenData(page = 1){
			this.loadConsumen=true
			var self = this
			await api({
				url:config.baseApi+'consumen?page=' + page,
				method:'GET'
			}).then(response => {
				this.consumen = response.data.data.consumen
				this.totalConsumen = response.data.data.total
			}).catch(error => {
				return error
			})
			this.loadingConsumen=false
		},

		async Product(){
			this.loadingProduct = true
			await api({
				url: config.baseApi + "product",
	          	method: 'get'
	      	})
	      	.then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.product = res.data.data.product
					this.totalProduct = res.data.data.total
				}
	      	})
	      	.catch(err => {
	      		return err
	      	})
	      	this.loadingProduct=false
		},
		async getAllHSM(page = 1){
			this.loadingTemplate = true
			var self = this      
			await api({
				url:config.baseApi+'hsm',
				method:'GET'
			}).then(response => {
				// console.log(response)
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.totalTemplate = response.data.data.total
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		}
	},
	async mounted(){
		await this.loadConsumenData()
		this.Product()
		this.getAllHSM()
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
	}
.no-shadow {
	text-shadow: none;
}
.white-text {
	color: $text-color;
}
.black-text {
	color: black;
}
.page-header {
	margin-bottom: 30px;
}
.width{
	width:10px;
}
</style>

<style lang="scss">

.page-dashboard {
	.widget {
		.peity {
			position: absolute;
			bottom: -1px;
			left: 0;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}
	table.styled {
		.peity {
			margin-right: 10px;
		}
	}

	.vb-content {
		padding: 0 20px;
		box-sizing: border-box !important;
		margin-top: -5px;
		margin-left: -20px;
		margin-right: -20px;
		height: calc(100% + 15px) !important;
		width: calc(100% + 40px) !important;
	}
}

@media (max-width: 768px) {
	.page-dashboard {
		.vb-content {
			padding: 0 5px !important;
			margin: -5px;
			width: calc(100% + 10px) !important;
		}
	}
}
</style>
